import { render, staticRenderFns } from "./Buttons.vue?vue&type=template&id=3e280bee&scoped=true&"
import script from "./Buttons.vue?vue&type=script&lang=js&"
export * from "./Buttons.vue?vue&type=script&lang=js&"
import style0 from "./Buttons.vue?vue&type=style&index=0&id=3e280bee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e280bee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\soiko\\Documents\\Projects\\game\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e280bee')) {
      api.createRecord('3e280bee', component.options)
    } else {
      api.reload('3e280bee', component.options)
    }
    module.hot.accept("./Buttons.vue?vue&type=template&id=3e280bee&scoped=true&", function () {
      api.rerender('3e280bee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Journal/Buttons.vue"
export default component.exports